var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.commerce.online_configuration.usar_cupones)?_c('div',{staticClass:"background"},[_c('h5',[_vm._v(" Cupones ")]),_c('search-component'),(_vm.cupon)?_c('cupon-card',{attrs:{"cupon":_vm.cupon}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }